import React from 'react';
import Card from '../../components/common/Card/Card';
import ChatInterface from '../../components/chat/ChatInterface/ChatInterface';
import './Chat.css';

const Chat = () => {
  return (
    <div className="chat-page">
      <div className="chat-header">
        <h1 className="chat-title">AI Chat Assistant</h1>
        <p className="chat-subtitle">
          Get AI-powered insights and analysis for your stock research
        </p>
      </div>

      <div className="chat-container">
        <Card className="chat-card">
          <ChatInterface />
        </Card>
      </div>
    </div>
  );
};

export default Chat; 